import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { createProvider, Step } from '../../../../../../shared/IFE/step/step/step';
import { UntypedFormArray, UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ImageInfo, Status } from 'src/app/shared/IFE/components/file-picker/models/imageInfo.interface';
import { finalize, take } from 'rxjs/operators';
import { DeviceDetectorService } from 'ngx-device-detector';
import { EvcApiService } from 'src/app/shared/modules/evc-api/services/evc-api.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { AnalyticsService } from '../../../../../../shared/modules/analytics/services/analytics.service';
import { TechnicalDetailsSteps } from '../../models/technical-details-steps';

@Component({
  selector: 'evc-quote-technical-details-main-fuse',
  providers: [createProvider(MainFuseComponent)],
  templateUrl: './main-fuse.component.html',
  styleUrls: ['./main-fuse.component.scss'],
})
export class MainFuseComponent extends Step implements OnInit {
  @Output() continueLater: EventEmitter<any> = new EventEmitter<any>();

  readonly formName = 'evcQuote';
  readonly stepName: string = 'technical-details-main-fuse';

  // Used to generate our QR code.
  href = window.location.href;
  // To upload our image and display it back.
  quoteId = this.route.snapshot.queryParams.id;
  baseUrl = `${environment.evcApi}/api/quotes/${this.quoteId}/images/thumbnail/`;

  // Used to hide Qr code on mobile/tablet devices.
  isTablet = this.deviceService.isTablet();
  isDesktopDevice = this.deviceService.isDesktop();

  // Images array length.
  arrayCurrentLength = 0;
  numberOfImages = 2;

  constructor(
    fb: UntypedFormBuilder,
    analyticsService: AnalyticsService,
    private translate: TranslateService,
    private route: ActivatedRoute,
    private deviceService: DeviceDetectorService,
    private api: EvcApiService,
    private toastr: ToastrService
  ) {
    super(fb, analyticsService);
  }

  // Uploads the selected image and returns the image's (back-end) filename.
  // We use return the filename to the picker to display the selected image.
  processFile([imageFile, status]) {
    const formData = new FormData();
    formData.append('file', imageFile);
    this.api
      .uploadImage(this.quoteId, formData)
      .pipe(
        take(1),
        finalize(() => status(Status.init))
      )
      .subscribe(
        (res: ImageInfo) => {
          (this.control.get('value') as UntypedFormArray).insert(
            this.arrayCurrentLength,
            this.fb.control(res.filename)
          );
        },
        (err) => {
          this.toastr.error(this.translate.instant('errorMessages.imageUploadFailed'));
          throw err;
        }
      );
  }

  // Delete our image
  deleteFile(index: number) {
    this.api.deleteImage(this.quoteId, this.control.get('value').value[index]).pipe(take(1)).subscribe();
    (this.control.get('value') as UntypedFormArray).removeAt(index);
  }

  // Overwrite the steps writeValue() func,
  // Retrieves the form values, and pre-fills the page
  writeValue(value): void {
    if (!value) {
      super.writeValue(value);
      return;
    }

    value.forEach((image) => {
      (this.control.get('value') as UntypedFormArray).push(this.fb.control(image));
    });
    super.writeValue(value);
  }

  goToContinueLater() {
    this.continueLater.emit(TechnicalDetailsSteps.mainFuse);
  }

  protected valueChanges(values) {
    super.valueChanges(values.value);
    this.arrayCurrentLength = values.value.length;
  }

  protected buildForm() {
    this.control = this.fb.group({
      value: this.fb.array([]),
    });
    this.subscribeToValueChanges(false);
  }
}
